import SSocket from "servisofts-socket";
import Model from "../../../../Model";

export default class ActionMusculo {

    static async getAll() {
        const resp = await SSocket.sendPromise({
            component: "tutorial_musculo",
            type: "getAll",
        })
        return Object.values(resp.data);
    }
    static async getAllPublicaciones() {
        const resp = await SSocket.sendPromise({
            component: "tutorial_musculo_publicacion",
            type: "getAll",
        })
        return Object.values(resp.data);
    }
    static async crear(data: { descripcion: string }) {
        const resp = await SSocket.sendPromise({
            component: "tutorial_musculo",
            type: "registro",
            data: data,
            key_usuario: Model.usuario.Action.getKey(),
        })
        return resp.data;
    }
    static async editar(data: any) {
        const resp = await SSocket.sendPromise({
            component: "tutorial_musculo",
            type: "editar",
            data: data,
            key_usuario: Model.usuario.Action.getKey(),
        })
        return resp.data;
    }
    static async eliminar(key: string) {
        const resp = await SSocket.sendPromise({
            component: "tutorial_musculo",
            type: "editar",
            data: {
                key: key,
                estado: 0
            },
            key_usuario: Model.usuario.Action.getKey(),
        })
        return resp.data;
    }
}